<template>
  <div v-if="!tempDes" class="form-floating" :class="'mb-'+mb">
    <input
        class="form-control form-control-solid"
        autocomplete="off"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :value="modelValue"
        :tokens="mask_token"
        :autofocus="autofocus"
        :type="type"
        :name="name"
        :id="id"
        :class="hasError ? 'is-invalid' : ''"
        v-mask="mask"
        @input="updateValue"
    >
    <label :for="id" :class="{ required: required }" v-html="placeholder"></label>
    <slot></slot>
  </div>
  <disabled-field v-else :value="text ?? modelValue" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'InputMaskField',
  components: {DisabledField},
  props: {
    placeholder: null,
    modelValue: '',
    mask_token: '',
    required: false,
    autofocus: false,
    disabled: null,
    hasError: false,
    class: null,
    type: null,
    mask: '',
    name: null,
    mb:null,
    id:null,
    max: null,
    min: null
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value)
      this.text = event.target.value
    }
  },
  data() {
    return {
      tempDes: false,
      text:null
    }
  },
  mounted() {
    if (this.disabled) {
      setTimeout(() => {this.tempDes = this.disabled}, 1)
    }
  },
}
</script>

<style scoped>

</style>